module.exports = __webpack_public_path__ + "img/playhub.e4bd216c.png";